module.exports = "sup {\n    color: red;\n    padding: 0 0 0 5px;\n    margin: 0;\n    font-size: 100%;\n}\n\nsmall {\n    color: rgb(153, 153, 153)\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/communication/add/communication-add.component.css
// module id = ./src/app/agora/components/account-data/communication/add/communication-add.component.css
// module chunks = main